const SimpleScenario = {
    "name": "Simple Scenario",
    "guid": "387b87d5-a933-47a8-a94c-6a8d7098faf5",
    "day_duration": 300,
    "night_duration": 40,
    "raw_scenario": [
        "Sheriff",
        "Doctor",
        "Citizen + BusDriver",
        "TownRandom - Citizen",
        "Citizen",
        "Citizen",
        "Citizen",
        "Citizen",
        "BusDriver",
        "Mafioso",
        "Mafioso",
        "Godfather",
        "Survivor"
    ],
    "rules_diff": []
};

export default SimpleScenario;